import { BToast } from "bootstrap-vue";

export default {
  success(title, message) {
    this.display(title, message, "success");
  },
  warning(title, message){
    this.display(title, message, "warning");
  },
  error(title, message, ex = null) {
    let messageToShow = message;
    let additionalMessageData = null;

    if (
      ex &&
      ex.response &&
      (ex.response.data.errors || ex.response.data.title || ex.response.data.message)
    ) {
      if (ex.response.data.errorMessages && ex.response.data.errorMessages.length > 0)
        additionalMessageData = (ex.response.data.errorMessages as string[]).join(" ");
      else {
        additionalMessageData =
          (ex.response.data.title ? ex.response.data.title : ex.response.data.message) + "\n";
        if (ex.response.data.errors) {
          let error = ex.response.data.errors;
          let propertyNames = Object.getOwnPropertyNames(error);
          propertyNames.forEach(prop => {
            if (prop && error[prop]) additionalMessageData += "*" + error[prop].join(", ") + "\n";
          });
        }
      }

      if (!messageToShow.endsWith(".")) {
        messageToShow += ".";
      }

      messageToShow += ` ${additionalMessageData}`;
    }

    this.display(title, messageToShow, "danger");
  },
  display(title, message, variant) {
    const toast = new BToast();
    toast.$bvToast.toast(message, {
      bodyClass: "word-break-all",
      title: title,
      variant: variant,
      solid: true
    });
  },
  showRefresh(title, message, variant = null, noAutoHide = false,noCloseButton = false ) {
    const toast = new BToast();
    toast.$bvToast.toast(message, {
      href: window.location.href,
      title: title,
      autoHideDelay:process.env.VUE_APP_CHECK_VERSION_IN_MINUTES * 60 * 1000,
      noAutoHide,
      noCloseButton,
      bodyClass: 'text-decoration-none'
    });
  }
};
